import BrandLogo from "@/components/BrandLogo";

/**
 * PoweredByStrip — strip orizzontale sottile "Powered by GestAgePro"
 * da mettere in cima o in fondo a pagine pubbliche multi-tenant che
 * mantengono il branding dell'agenzia. Non sostituisce il logo agenzia,
 * ma aggiunge il brand della piattaforma in modo coerente.
 */
export default function PoweredByStrip({ position = "top", testId = "powered-by-strip" }) {
  const border = position === "top" ? "border-b" : "border-t";
  return (
    <div
      className={`w-full bg-slate-900 text-white ${border} border-slate-700`}
      data-testid={testId}
    >
      <div className="max-w-6xl mx-auto px-4 py-1.5 flex items-center justify-between gap-3 text-xs">
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold">
            Powered by
          </span>
          <BrandLogo size="sm" showText testId={`${testId}-logo`} />
        </div>
        <a
          href="/landing"
          className="hidden sm:inline text-[10px] uppercase tracking-wider text-slate-300 hover:text-white transition-colors"
          data-testid={`${testId}-link`}
        >
          Scopri la piattaforma →
        </a>
      </div>
    </div>
  );
}
